import type { FC } from 'react';
import type { Section } from '../copy';
import { CopyLine } from './CopyLine';

// One body section: heading + one or more paragraphs. Reused for all three
// product sections on the page; data-driven from copy.SECTIONS.
export const OnePagerSection: FC<{ section: Section }> = ({ section }) => (
  <section>
    <h2
      className="m-0 mb-3 text-[19px] font-semibold leading-[1.25] md:text-[22px]"
      style={{ letterSpacing: '-0.005em' }}
    >
      {section.heading}
    </h2>
    {section.body.map((line, i) => (
      <p
        key={i}
        className={`m-0 ${i < section.body.length - 1 ? 'mb-3' : ''}`}
      >
        <CopyLine line={line} />
      </p>
    ))}
  </section>
);
